import { render, staticRenderFns } from "./codeLayout.vue?vue&type=template&id=b542e558&scoped=true&"
import script from "./codeLayout.vue?vue&type=script&lang=js&"
export * from "./codeLayout.vue?vue&type=script&lang=js&"
import style0 from "./codeLayout.vue?vue&type=style&index=0&id=b542e558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b542e558",
  null
  
)

export default component.exports